import { Category } from '@core/domain/models/category.models';
import { checkAttachmentName } from '@features/category/application/services/category.utils';
import { AttachmentsEnums } from '@shared/header/services/attachments.enums';
import { GridTypes } from '@shared/models/grid-type.model';

export function checkForceViewAttachmentsUseCase(category: Category): AttachmentsEnums {
    const attachmentsToCheck = [
        AttachmentsEnums.FORCE_VIEW_STUDIO,
        AttachmentsEnums.FORCE_VIEW_12,
        AttachmentsEnums.FORCE_VIEW_6,
        AttachmentsEnums.HIDE_GRID_VIEW_SELECTOR,
    ];

    return attachmentsToCheck.find(attachmentKey => checkAttachmentName(category, attachmentKey));
}

export function getForcedGridTypeUseCase(attachment: AttachmentsEnums): number {
    switch (attachment) {
        case AttachmentsEnums.FORCE_VIEW_STUDIO:
            return GridTypes.ZARA_STUDIO;
        case AttachmentsEnums.FORCE_VIEW_12:
            return GridTypes.GRID_16;
        case AttachmentsEnums.FORCE_VIEW_6:
            return GridTypes.GRID_4;
        case AttachmentsEnums.HIDE_GRID_VIEW_SELECTOR:
            return GridTypes.ZARA_STUDIO;
        default:
            return null;
    }
}
